import { color, font } from "@smoothincorg/smooth-ui"
import React from "react"
import styled, { css } from "styled-components"

type Props = {
  className?: string
  items: [string, string | number | JSX.Element][]
}

const Component: React.VFC<Props> = (props) => {
  return (
    <ul className={`${props.className} vercelist`}>
      {props.items.map(([title, content]) => {
        return (
          <li className={`${props.className}-item`} data-title={title} key={title}>
            <span className={`${props.className}-item__title`}>{title}</span>
            <span className={`${props.className}-item__content`}>{content}</span>
          </li>
        )
      })}
    </ul>
  )
}

export const vercelistStyle = css`
  &-item {
    font-weight: bold;
    padding-right: 45px;
    white-space: pre-wrap;

    &__title {
      ${font(13)};
      display: block;
      color: ${color.darkGray};

      > button {
        font-weight: normal;
        ${font(12)};
      }
    }

    &__content {
      ${font(15)};
      display: block;
    }
  }
`

const StyledComponent = styled(Component)`
  ${vercelistStyle}
`

export const Vercelist = StyledComponent
